import { render } from "./ClinicalSectionDetailsWithOATS.vue?vue&type=template&id=2e0961f7&scoped=true"
import script from "./ClinicalSectionDetailsWithOATS.vue?vue&type=script&lang=js"
export * from "./ClinicalSectionDetailsWithOATS.vue?vue&type=script&lang=js"

import "./ClinicalSectionDetailsWithOATS.vue?vue&type=style&index=0&id=2e0961f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0961f7"],['__file',"src/components/ClinicalSectionDetailsWithOATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e0961f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e0961f7', __exports__)) {
    api.reload('2e0961f7', __exports__)
  }
  
  module.hot.accept("./ClinicalSectionDetailsWithOATS.vue?vue&type=template&id=2e0961f7&scoped=true", () => {
    api.rerender('2e0961f7', render)
  })

}


export default __exports__